import React from 'react';
import { Container, Footer, Title, Value } from './styles';

import { Typography } from '@mui/material';
import CountUp from 'react-countup';

interface KpiCardProps {
  title: string;
  value: number;
  icon: React.ReactElement;
  currency?: boolean;
  percent?: boolean;
  backgroundColor?: string;
}

const KpiCard: React.FC<KpiCardProps> = ({
  title,
  value,
  currency = false,
  percent = false,
  backgroundColor,
  icon,
}) => {
  return (
    <Container backgroundColor={backgroundColor}>
      {React.cloneElement(icon, { className: 'icon' })}
      <Title>{title}</Title>
      <Value>
        {currency && (
          <Typography
            variant="h5"
            color="white"
            sx={{
              fontWeight: 600,
              marginTop: '15px',
              marginRight: '5px',
            }}
          >
            R$
          </Typography>
        )}

        {value % 1 !== 0 ? (
          <CountUp
            duration={2}
            end={value}
            decimals={2}
            decimal=","
            style={{ fontSize: 52 }}
          />
        ) : currency ? (
          <CountUp
            duration={2}
            decimals={2}
            end={value}
            decimal=","
            style={{ fontSize: 52 }}
          />
        ) : (
          <CountUp
            duration={2}
            end={value}
            decimal=","
            style={{ fontSize: 52 }}
          />
        )}

        {percent && (
          <Typography
            variant="h5"
            color="white"
            sx={{
              fontWeight: 600,
              marginTop: '15px',
              marginLeft: '5px',
            }}
          >
            %
          </Typography>
        )}
      </Value>
    </Container>
  );
};

export default KpiCard;
